<template>
    <title name="title">Whoops! Are you lost?</title>
    <div class="flex justify-center">
        <div class="flex flex-col items-center px-5">
            <img class="w-[200px] mt-8" 
                src="/images/master-not-found.png" />
            <h1 class="mt-7 text-[22px] md:text-[30px] font-bold text-center">
                There is nothing to show here
            </h1>
            <h3 class="mt-3 text-[20px] md:text-[17px] text-center">
                Are you looking for a personal trainer? Let us help you find one.
            </h3>
            <div class="flex flex-col items-center">
                <Link href="/">
                    <button class="custom-button w-full bg-yellow-400 text-lg shadow-md mt-7 
                        px-3 py-1 rounded-full text-white hover:shadow-xl transition duration-500 
                        ease-in-out hover:bg-yellow-500 focus:ring focus:ring-yellow-500">
                        Explore personal trainers
                    </button>
                </Link>
                <a href="mailto:support@happytrainers.com" target="_blank"
                    class="mt-3 text-[17px]"> Contact support </a>
            </div>
        </div>
    </div>
</template>
<script>
import {Link} from '@inertiajs/inertia-vue3';

export default {
    components: { Link },
    data() {
        return {

        }
    },
}
</script>